/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KoreaStockReturnProcessGoodsInfoVo
 */
export interface KoreaStockReturnProcessGoodsInfoVo {
    /**
     * 商品ID
     * @type {number}
     * @memberof KoreaStockReturnProcessGoodsInfoVo
     */
    goodsId?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof KoreaStockReturnProcessGoodsInfoVo
     */
    goodsCode?: string;
    /**
     * SKU ID
     * @type {number}
     * @memberof KoreaStockReturnProcessGoodsInfoVo
     */
    skuId?: number;
    /**
     * SKU 编码
     * @type {string}
     * @memberof KoreaStockReturnProcessGoodsInfoVo
     */
    skuCode?: string;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof KoreaStockReturnProcessGoodsInfoVo
     */
    imgUrl?: string;
    /**
     * 数量
     * @type {number}
     * @memberof KoreaStockReturnProcessGoodsInfoVo
     */
    quantity?: number;
    /**
     * 单价
     * @type {number}
     * @memberof KoreaStockReturnProcessGoodsInfoVo
     */
    unitPrice?: number;
    /**
     * 货位号
     * @type {Array<string>}
     * @memberof KoreaStockReturnProcessGoodsInfoVo
     */
    locations?: Array<string>;
    /**
     * 处理方式 1 废弃 7 回库
     * @type {number}
     * @memberof KoreaStockReturnProcessGoodsInfoVo
     */
    processMethod?: number;
}

/**
 * Check if a given object implements the KoreaStockReturnProcessGoodsInfoVo interface.
 */
export function instanceOfKoreaStockReturnProcessGoodsInfoVo(value: object): value is KoreaStockReturnProcessGoodsInfoVo {
    return true;
}

export function KoreaStockReturnProcessGoodsInfoVoFromJSON(json: any): KoreaStockReturnProcessGoodsInfoVo {
    return KoreaStockReturnProcessGoodsInfoVoFromJSONTyped(json, false);
}

export function KoreaStockReturnProcessGoodsInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaStockReturnProcessGoodsInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'goodsCode': json['goodsCode'] == null ? undefined : json['goodsCode'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'locations': json['locations'] == null ? undefined : json['locations'],
        'processMethod': json['processMethod'] == null ? undefined : json['processMethod'],
    };
}

export function KoreaStockReturnProcessGoodsInfoVoToJSON(json: any): KoreaStockReturnProcessGoodsInfoVo {
    return KoreaStockReturnProcessGoodsInfoVoToJSONTyped(json, false);
}

export function KoreaStockReturnProcessGoodsInfoVoToJSONTyped(value?: KoreaStockReturnProcessGoodsInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'goodsCode': value['goodsCode'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'imgUrl': value['imgUrl'],
        'quantity': value['quantity'],
        'unitPrice': value['unitPrice'],
        'locations': value['locations'],
        'processMethod': value['processMethod'],
    };
}

